import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { modals } from 'helpers'

import Button from 'components/ui/Button/Button'
import Modal from 'components/Modal/Modal'
import Box from 'components/layout/Box/Box'

import s from './ContentModal.scss'


class ContentModal extends PureComponent {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: modals.Content,
  }

  close = () => {
    const { name } = this.props

    actions.modals.close(name)
  }

  handleButtonClick = () => {
    const { data: { onButtonClick } } = this.props

    this.close()

    if (typeof onButtonClick === 'function') {
      onButtonClick()
    }
  }

  render() {
    const { data: { title, text, content, buttonTitle } } = this.props

    return (
      <Modal onClose={this.close}>
        <div>
          {
            Boolean(title) && (
              <div className={s.title} dangerouslySetInnerHTML={{ __html: title }} />
            )
          }
          {
            Boolean(content) && content
          }
          {
            Boolean(text) && (
              <Box pt={16}>
                <div className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
              </Box>
            )
          }
          {
            Boolean(buttonTitle) && (
              <Button
                className={s.button}
                title={buttonTitle}
                green
                fullWidth
                onClick={this.handleButtonClick}
              />
            )
          }
        </div>
      </Modal>
    )
  }
}


export default ContentModal
